module.exports = __webpack_public_path__ + "img/liangfurong.7ec5abf9.png";